import { GET, PATCH, POST } from "../../helper/xbi4RestFunctions";
export const getEmployeeCurrentMonthLeave = async (
  org_id: any,
  org_user_id: any,
  month:any,
  year:any
) => {
  const path = `/orgs/${org_id}/users/${org_user_id}/time_off_details/current_month?month=${month}&year=${year}`;
  return await GET(path)
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error on fetching objective >", err);
      return err;
    });
};